'use strict';

angular.module('atex.art').directive('autofocus', function() {
  return {
    scope: true,
    link: function(scope, elem, attrs) {
      var autofocus = scope.$eval(attrs['autofocus']) || false;

      if (autofocus === true) {
        elem.prop('autofocus', true);
      }
    }
  };
});
